import type { ProductGalleryAsset } from "@jti/fe-common";

export const getFilteredImagesByRole = (images: ProductGalleryAsset[], roleToFilter: string): ProductGalleryAsset[] => {
  return images.filter((image) => {
    return !image.role?.includes(roleToFilter);
  });
};
